import React, {Component} from "react"
import PropTypes from "prop-types"
import {get, uniq, find} from "lodash"

import {connect} from "@irati/store"
import {injectIntl} from "@irati/utils/lang"
import {Select} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import Loading from "@irati/ui/src/Loading"
import authentication from "@irati/auth"
import TeamActions from "@irati/identity/store/actions/TeamActions"
import id from "@irati/utils/id"

export const PROPERTY = "preferences.teamIds"

export const schema = (formatMessage, required) => {
  const requiredMessage = formatMessage({id: "insights.validation.required"})
  return Validation.array(required ? requiredMessage : null).of(
    Validation.object().shape({
      value: Validation.string(requiredMessage)
    })
  )
}

class TeamIds extends Component {
  static propTypes = {
    getTeams: PropTypes.func.isRequired,
    teams: PropTypes.array.isRequired,
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    validation: PropTypes.object,
    formatMessage: PropTypes.func.isRequired
  }

  static defaultProps = {
    label: `insights.fields.schedule.${PROPERTY}.label`,
    placeholder: `insights.fields.schedule.${PROPERTY}.placeholder`,
    required: true,
    hint: null,
    allowPaste: true,
    isClearable: true,
    validation: null
  }

  constructor(props) {
    super(props)
    this.state = {}

    const optionsLoad = props.getTeams().then(() => {
      const {teams} = this.props
      this.setState({
        options: teams.map((team) => ({
          label: team.public_name,
          value: team.uuid
        }))
      })
    })

    this.state.optionsLoad = optionsLoad
  }

  handleChange = (values) => {
    const {onChange, schedule} = this.props
    const teamIds = values.length > 0 ? uniq(values.map((item) => item.value)) : []
    onChange(schedule, PROPERTY, teamIds)
  }

  render() {
    const {schedule, label, required, placeholder, validation, formatMessage, ...props} = this.props
    const idNamespace = id("TeamIds", props)
    const property = get(schedule, PROPERTY) || []

    const intlLabel = formatMessage({id: label})
    const intlPlaceholder = formatMessage({id: placeholder})

    /** Map values array to the options array */
    const values = property.map((team) => {
      return find(this.state.options, {value: team})
    })

    return (
      <Loading id={idNamespace} load={this.state.optionsLoad}>
        <Select
          {...props}
          isMulti
          name={PROPERTY}
          id={idNamespace}
          placeholder={intlPlaceholder}
          value={values}
          options={this.state.options}
          onChange={this.handleChange}
          label={intlLabel} />
      </Loading>
    )
  }
}

const mapStateToProps = ({teams}) => ({teams: teams.list})

const actions = (dispatch) => {
  return {
    getTeams: () => dispatch(TeamActions.get(authentication.userTenant()))
  }
}

export default injectIntl(
  connect(
    mapStateToProps,
    actions
  )(TeamIds)
)
